import React from 'react';
import { connect } from 'react-redux';
import {
  deleteScreener,
  updateScreener,
  changeScreener,
  REDUCER_NAME,
} from '../reducer';
import ScreenerItem from './ScreenerItem';
import ScrollComponent from '../../../common/ScrollComponent';

class ListScreener extends React.Component {
  render() {
    const {
      listScreener,
      editAction,
      deleteAction,
      isTopScreener,
      changeScreener,
      showHide,
      listParam,
    } = this.props;

    return (
      listScreener.length > 0 && (
        <div
          className="my-screeners"
          style={{
            position: 'absolute',
            transform: 'translate3d(-110px, 20px, 0px)',
            top: '20%',
            left: '0%',
            zIndex: '9999',
            willChange: 'transform',
          }}
        >
          <ScrollComponent appendStyle={{ maxHeight: 177 }}>
            <div className="myscreener-content">
              {listScreener.map((value, index) => {
                return (
                  <ScreenerItem
                    showHide={showHide}
                    key={index}
                    screener={value}
                    editAction={editAction}
                    deleteAction={deleteAction}
                    changeScreener={changeScreener}
                    isTopScreener={isTopScreener}
                    listOriginParam={listParam}
                  />
                );
              })}
            </div>
          </ScrollComponent>
        </div>
      )
    );
  }
}

const mapStateToProps = state => ({
  listParam: state[REDUCER_NAME].listParam,
});

const mapDispatchToProps = dispatch => ({
  deleteAction: id => dispatch(deleteScreener(id)),
  editAction: (id, name) => dispatch(updateScreener(id, name)),
  changeScreener: (id, isTopScreener) =>
    dispatch(changeScreener(id, isTopScreener)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ListScreener);
